export default __webpack_public_path__ + "static/media/Logo_Bn.1265b635.png";